import { render, staticRenderFns } from "./PromoteViewItem.vue?vue&type=template&id=8d78df26&scoped=true&"
import script from "./PromoteViewItem.vue?vue&type=script&lang=ts&"
export * from "./PromoteViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./PromoteViewItem.vue?vue&type=style&index=0&id=8d78df26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d78df26",
  null
  
)

export default component.exports